
import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';
import { getDefaultAccountBudgetStartDate } from '../helpers/helpers';
import { Budget, BudgetSummaryTaxType } from 'globals/store/budget.data';
import { eventsActions } from './events.era';

const LOAD_BUDGET = '[budget] LOAD_BUDGET'
const REMOVE_ACCOUNT_BUDGETS = '[budget] REMOVE_ACCOUNT_BUDGETS'
const LOAD_ACCOUNT_BUDGETS = '[budget] LOAD_ACCOUNT_BUDGETS'
const UPDATE_SUMMARY_START_DATE = '[budget] UPDATE_SUMMARY_START_DATE'
const UPDATE_SUMMARY_TAX_TYPE = '[budget] UPDATE_SUMMARY_TAX_TYPE'


export interface BudgetState {
  budget: Budget
  budgets: Dictionary<Budget>
  summaryStartDate: Date
  summaryTaxType: BudgetSummaryTaxType
}

const getDefaultBudgetState = (): BudgetState => ({
  budget: null,
  budgets: {},
  summaryStartDate: getDefaultAccountBudgetStartDate(),
  summaryTaxType: 'both'
})

export const budgetActions = createActionGroup({
  source: 'Budget',
  events: {
    'Load Budget': (budget: Budget) => ({ budget }),
    'Load Account Budgets': (budgets: Budget[]) => ({ budgets }),
    'Remove Account Budgets': (ids: string[]) => ({ ids }),
    'Update Summary Start Date': (date: Date) => ({ date }),
    'Update Summary Tax Type': (taxType: BudgetSummaryTaxType) => ({ taxType })
  }
})

export const budgetReducer = createReducer(
  getDefaultBudgetState(),
  on(budgetActions.loadBudget, (state, { budget }) => ({ ...state, budget })),
  on(budgetActions.loadAccountBudgets, (state, { budgets }) => {
    const newBudgets = { ...state.budgets }
    budgets.forEach(b => newBudgets[b.eventId] = b)
    return { ...state, budgets: newBudgets }
  }),
  on(budgetActions.removeAccountBudgets, (state, { ids }) => {
    const newBudgets = { ...state.budgets }
    ids.forEach(id => delete newBudgets[id])
    return { ...state, budgets: newBudgets }
  }),
  on(budgetActions.updateSummaryStartDate, (state, { date }) => ({ ...state, summaryStartDate: date })),
  on(budgetActions.updateSummaryTaxType, (state, { taxType }) => ({ ...state, summaryTaxType: taxType })),
  on(eventsActions.unloadEvent, (state) => getDefaultBudgetState())
)

export const budgetFeature = createFeature({
  name: 'budget',
  reducer: budgetReducer
});

export const budgetStateSelector = createFeatureSelector<BudgetState>(budgetFeature.name)